// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  CHANGE_ASSETS_VISIBILITY,
  normalizeCompanyEditOptions,
} from '@/utilities/companyAssetsVisibilityAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
} from '@/features/acl-settings/aclSettingsUi';
import { ShieldAlert } from 'lucide-react';

const CompanyAssetsVisibilityAclModal = ({
  show,
  onHide,
  initialOptions,
  optionsConfigured = false,
  onSave,
  limitedByParent = false,
  canGrantAssetsVisibility = true,
}) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!show) return;

    const options = normalizeCompanyEditOptions(
      Array.isArray(initialOptions) ? initialOptions : [],
    );

    // Off until ticked, even when the parent could grant it.
    setEnabled(optionsConfigured ? options.includes(CHANGE_ASSETS_VISIBILITY) : false);
  }, [show, initialOptions, optionsConfigured]);

  const handleReset = () => setEnabled(false);

  const handleSave = () => {
    onSave({ edit_options: enabled ? [CHANGE_ASSETS_VISIBILITY] : [] });
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Companies — Assets Visibility"
      icon={ShieldAlert}
      description="Grant permission to switch a company's assets between private and public."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canGrantAssetsVisibility}
    >
      <AclModalSection
        icon={ShieldAlert}
        title="Change Assets Visibility"
        subtitle="Allow switching assets between private and public."
      >
        {!canGrantAssetsVisibility ? (
          <p className="acl-modal-empty">
            You do not have permission to grant assets visibility changes.
          </p>
        ) : (
          <>
            <AclModalOptionCheck
              id="company-acl-assets-visibility"
              label="Change Assets Visibility"
              description="Allow switching a company's assets between private and public"
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
            />
          </>
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default CompanyAssetsVisibilityAclModal;
